<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <TopPreSalePanel
          name-dashbords="Pre-sale"
          :is-dashboard-selected="isDashboardSelected"
          @expand-dashboard="handleExpandDashboard"
        ></TopPreSalePanel>
        <DashboardsViewForm
          ref="dashboardsFormRef"
          :store="workbooksStore"
          type="own_workbook"
          :hide-expand-button="true"
          :default-workbook="42"
          :default-dashboard="52"
          @dashboard-selected="updateDashboardSelection"
        ></DashboardsViewForm>
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
// Используются конкретные id воркбука и дашборда, потому что это страница конкретного дашборда!!! Может не отображаться при перезаливе бд
import { computed, ref } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopPreSalePanel from "@/entities/analytics/dashboards/TopPreSalePanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useClientWorkbooksStore } from "@/store/catalog_data/client_reports";
import { rootGetters } from "@/main";

const authStore = useAuthStore();
const workbooksStore = useClientWorkbooksStore();
const dashboardsFormRef = ref();
const isDashboardSelected = ref(true);

const isDenied = computed(() => {
  const isInhouseUser =
    authStore.getPayloadTenant() === rootGetters.inhouse_tenant;

  if (!isInhouseUser) {
    return true;
  }

  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"]
  );
});

const handleExpandDashboard = () => {
  if (dashboardsFormRef.value) {
    dashboardsFormRef.value.expandDashboard();
  }
};

// Метод для обновления состояния выбранного дашборда
const updateDashboardSelection = (selected: boolean) => {
  isDashboardSelected.value = selected;
};
</script>
